module.exports = __webpack_public_path__ + "front/img/d1.ab07a112.png";